import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import Link from '@buyside/components/presentation/Link/link';
import ProfileImage from '@buyside/components/presentation/ProfileImage/profileImage';

import { defaultUserImageUrl, messageUrl } from '@buyside/util/urlHelper';

import { Maybe, Message as MessageType, User } from '@interfaces/graphql-typings';

import styles from './navigationMessagesStyles.scss';

const NavigationMessage: React.FC<{
  message: Pick<MessageType, 'id' | 'receiverStatus' | 'threadCount' | 'body' | 'createdAt'> & {
    sender: Maybe<Pick<User, 'id' | 'displayName' | 'profileImageUrl'>>;
  };
}> = ({ message }) => {
  return (
    <Link
      data-testid="navigation-message"
      className={classNames(styles.message, {
        [styles.isUnread]: message.receiverStatus === 'unread'
      })}
      to={messageUrl(message.id)}
      key={message.id}
    >
      <div className={styles.messageHeader}>
        <ProfileImage
          noMargin
          size="small"
          source={message.sender?.profileImageUrl || defaultUserImageUrl()}
        />
        <div className={styles.senderInfo}>
          <div>
            {message?.sender?.displayName || 'Former User'}{' '}
            {Number(message?.threadCount) > 1 ? `(${message.threadCount})` : ''}
          </div>
          <div>{moment(new Date(message.createdAt || '')).format('M/D/YY')}</div>
        </div>
      </div>
      <div className={styles.messageBody}>
        <p>{message.body}</p>
      </div>
    </Link>
  );
};

export default NavigationMessage;
